import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {FONT, COLOR} from '../theme.js';

export function getBonusesConfig() {
    const COMMON_FUTURA = {
        fontFamily: FONT.FAMILY_FUTURA,
        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
        textTransform: 'uppercase',
        fontStyle: 'italic',
        fontSize: FONT.SIZE_MEDIUM,
    };

    return {
        palette: {
            [PALETTE_IDS.BONUSES]: {
                BONUSES_SECTION_TITLE_TEXT: {
                    ...COMMON_FUTURA,
                    fontSize: FONT.SIZE_XSMALL,
                    color: COLOR.BRAND.FOREGROUND2,
                },

                BONUS_ITEM_BG: COLOR.BRAND.BACKGROUND4,
                BONUS_ITEM_TITLE_TEXT: {
                    ...COMMON_FUTURA,
                    fontSize: FONT.SIZE_LARGE,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                BONUS_ITEM_STATUS_TEXT: COLOR.BRAND.FOREGROUND1,
                BONUS_ITEM_STEP_TITLE_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_STATUS_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                },
            },
        },
    };
}
